import React from "react";
import { formatTableDate } from "../../../../atoms/Chart";

import "./gold-rate.m.css";
import { formatRate } from "../../util";


const HistoricalGoldRateTable = ({ historicalRate }) => {

  const enable21Carat = historicalRate?.length > 0 && historicalRate?.[0]?.carat21 > 0;
  return <div styleName="gold-table-container">
    <table styleName="gold-rate-exchange-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>24 Carat</th>
          <th>22 Carat</th>
          { enable21Carat && <th>21 Carat</th> }
          <th>18 Carat</th>
        </tr>
      </thead>
      <tbody>
        {historicalRate?.length > 0 ? (
          historicalRate?.map((item) => (
            <tr key={item?.date}>
              <td>{formatTableDate(item?.date)}</td>
              <td>{formatRate(item?.carat24)}</td>
              <td>{formatRate(item?.carat22)}</td>
              {enable21Carat && <td>{formatRate(item?.carat21)}</td>}
              <td>{formatRate(item?.carat18)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5">No data available.</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
};

export default HistoricalGoldRateTable;
